/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';

import {Alert} from 'eui-components';
import {FormattedMessage} from 'react-intl';

/**
 * Error displayed when a domain application page returns a server error (non HTTP 200 status code).
 *
 * @param props component props
 * @returns {*} markup to display.
 * @constructor
 */
const DomainApplicationErrorView = (props) => {
  return (
    <div>
      <Alert bsStyle='danger'>
        <h4>
          <FormattedMessage id={'DomainApplicationErrorView.header'}
            defaultMessage={'We are unable to process your request at this moment.'}/>
        </h4>
        <p>
          <FormattedMessage id={'DomainApplicationErrorView.body'}
            defaultMessage={'There seems to be a problem with the application you are ' +
                              'accessing. Come back later or try a different application.'} />
        </p>
        {props.path && <p>{props.path}</p>}
      </Alert>
    </div>
  );
};

DomainApplicationErrorView.propTypes = {
  message: PropTypes.string,
  error: PropTypes.string,
  path: PropTypes.string,
  status: PropTypes.number
};

export default DomainApplicationErrorView;




// WEBPACK FOOTER //
// ./src/DomainApplicationView/DomainApplicationErrorView.js